<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (cancel)="cancel()"
  (confirm)="confirm($event)"
>
  <div class="spacing--margin-top">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'salesPotential.cropColumn' | translate }}</mat-label>
      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropfield-crop"
      />
      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops$ | async; track option.id) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (formGroup.get('cropId')?.hasError('required')) {
        <mat-error>
          {{ 'salesPotential.required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ 'salesPotential.areaColumn' | translate }}</mat-label>
      <input matInput type="number" formControlName="areaInHectares" step="0.01" />
      @if (formGroup.get('areaInHectares')?.hasError('required')) {
        <mat-error>
          {{ 'salesPotential.required' | translate }}
        </mat-error>
      }
      @if (formGroup.get('areaInHectares')?.hasError('min')) {
        <mat-error>
          {{ 'salesPotential.mustBePositive' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <div class="checkbox-group">
      <mat-checkbox formControlName="salesPotentialGbm" color="primary">
        {{ 'salesPotential.gbm' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="salesPotentialBem" color="primary">
        {{ 'salesPotential.fertilizer' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="salesPotentialSeed" color="primary">
        {{ 'salesPotential.seed' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="isSkal" color="primary">
        {{ 'salesPotential.organic' | translate }}
      </mat-checkbox>
    </div>
  </div>
</agr-form-dialog>
